import { apiClient } from './apiClient';
import { NextActionOption } from '../types/cpe';

interface NextActionOptionResponse {
  success: boolean;
  data: NextActionOption[];
}

interface NextActionOptionSingleResponse {
  success: boolean;
  data: NextActionOption;
}

class NextActionOptionService {
  private api = apiClient;

  /**
   * Get all next action options.
   * Admins see all including archived; regular users see only active ones.
   */
  async getAll(): Promise<NextActionOption[]> {
    const response = await this.api.get<NextActionOptionResponse>('/next-action-options');
    return response.data.data;
  }

  /**
   * Create a new next action option (admin only)
   */
  async create(name: string): Promise<NextActionOption> {
    const response = await this.api.post<NextActionOptionSingleResponse>(
      '/next-action-options',
      { name }
    );
    return response.data.data;
  }

  /**
   * Update an existing option — rename or toggle is_active (admin only)
   */
  async update(id: string, payload: { name?: string; is_active?: boolean }): Promise<NextActionOption> {
    const response = await this.api.put<NextActionOptionSingleResponse>(
      `/next-action-options/${id}`,
      payload
    );
    return response.data.data;
  }

  /**
   * Soft-delete an option (admin only)
   */
  async delete(id: string): Promise<void> {
    await this.api.delete(`/next-action-options/${id}`);
  }
}

export const nextActionOptionService = new NextActionOptionService();
export default nextActionOptionService;
